export const apiConstants = {
  url: "/api/item",
  category: "/api/itemcategory",
  suppliers: "/api/supplier"
};
